import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import List from './List/List'
import LevelDialog from './Dialog/Dialog'
import useLevels from '../../../../../hooks/curriculum/useLevels'
import InputField from '../../../../FormControl/input/InputField'

const Levels = () => {
  const [type, setType] = useState(null)
  const [form, setForm] = useState(null)
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState({});
  const permission = useSelector((state) => state?.session?.permissions ? state?.session?.permissions['curriculum-levels'] || {} : {})

  const listTemp = useSelector((state) => state?.curriculum?.levels || [])
  const { isLoadingList } = useLevels()

  const onModal = (type = null, form = {}) => {
    setType(type)
    setForm(form)
  }

  useEffect(() => {
    setList(listTemp)
  }, [listTemp])

  const onSearch = (key, value = '') => {
    setFilter({ ...filter, [key]: value });
    if (value.length === 0) {
      setList(listTemp);
    } else {
      const filterData = listTemp.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item?.code?.toLowerCase().includes(value.toLowerCase())
      );
      setList(filterData);
    }
  };

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>Levels</Typography>
        { permission['created'] && 
          <ButtonStartIcon
            onClick={() => onModal('create', {})}
            color='secondary'
            variant='contained'
            startIcon={["fas","plus"]}
          >
            Create
          </ButtonStartIcon>
        }
      </Box>
      <div className='flex gap-2 items-center justify-between items-center py-2'>
        <div className='flex gap-2 justify-start'>
          <ButtonStartIcon
            variant='text'
            startIcon='bars-filter'
            title='Filter'
            color='primary'
            classNameIcon='text-3xl'
            size='large'
          >
            Filter
          </ButtonStartIcon>
          <div className='max-w-250px'>
            <InputField placeholder='Search' onChange={(e) => onSearch('search', e.target.value)} />
          </div>
        </div>
      </div>
      <Box className='px-2 py-2 absolute top-24 bottom-0 inset-x-0'>
        <List
          isLoading={isLoadingList}
          list={list?.sort((a, b) => a.position - b.position) || []}
          permissions={permission}
          onAction={(type, form) => onModal(type, form)}
        />
      </Box>
      { type &&
        <LevelDialog 
          type={type}
          show={!!type} 
          onClose={() => onModal(null, {})} 
          data={form || {}}
        />
      }
    </>
  )
}

export default Levels